module.exports = __webpack_public_path__ + "img/about_bg.878bc75c.png";